<template>

<div class="item" :class="{'is-grow': grow, 'is-faded': faded, 'is-empty': isEmpty, 'has-link': link}" :data-theme="theme">

	<div class="item-label">{{ label }}</div>

	<div class="item-value">

		<div class="item-tag" v-if="tag" :data-status="status">{{ tag }}</div>

		<app-icon class="item-icon" :icon="icon" v-if="icon" />

		<a :href="'mailto:' + value" v-if="isEmail">{{ value }}</a>
		
		<template v-if="!isEmail">{{ (alt) ? value || alt : value }}</template>

		<div class="item-note" v-if="note">{{  note  }}</div>

		<slot></slot>

		<app-icon icon="open" class="item-link" v-if="link" v-on:click="onLinkClick" v-tooltip="'Click to view'" />

	</div>

</div>

</template>

<script>

export default {

	props: ['label', 'tag', 'status', 'alt', 'note', 'theme', 'faded', 'value', 'icon', 'isEmpty', 'grow', 'isEmail', 'link'],

	methods: {
	
		onLinkClick: function() {
		
			this.$router.push(this.link)
		
		}
	
	}

}

</script>

<style scoped>

.item {
	flex-shrink: 0;
	flex-basis: 0;
	padding: 20px;
	border-right: 1px solid #ddd;
}

.item:first-child {
	border-radius: 4px 0px 0px 4px;
}

.item[data-theme="grey"] {
	background-color: #939393;
	border-right: 0px;
}

.item[data-theme="blue"] {
	background-color: #4082d3;
	border-right: 0px;
}

.item[data-theme="green"] {
	background-color: #4faa80;
	border-right: 0px;
}

.item[data-theme="red"] {
	background-color: #c55b5b;
	border-right: 0px;
}

.item[data-theme="yellow"] {
	background-color: #ffbe7a;
	border-right: 0px;
	color: #333;
}


.is-mobile .item {
	border-right: 0px;
	padding: 10px;
	border-bottom: 1px solid #ddd;
}

.item.is-grow {	
	flex-grow: 1;
}

.item:last-child {
	border-right-width: 0px;
	border-bottom-width: 0px;
}

.item-label {
	font-size: 12px;
	color: #666;
	white-space: nowrap;
}

.item-value {
	font-size: 16px;
	margin-top: 10px;
	line-height: 20px;
	display: flex;
	color: #343434;
	align-items: center;
	white-space: nowrap;
}

.item.is-faded .item-value {
	color: #aaa;
}

.item[data-theme] .item-label {
	color: #fff;
}

.item[data-theme] .item-value {
	color: #fff;
}

.item[data-theme="yellow"] .item-label {
	color: #333;
}

.item.is-empty .item-value {
	color: #ccc;
}

.item-value a:hover {
	color: #4082d3;
}

.is-mobile .item-value {
	margin-top: 5px;
}

.item-tag {
	color: #fff;
	height: 20px;
	font-size: 16px;
	line-height: 20px;
	font-weight: 400;
	padding: 0px 4px;
	border-radius: 4px;
}

.item[data-theme] .item-tag {
	padding: 0px;
}

.item-tag[data-status="0"] {
	background-color: #c55b5b;
}

.item-tag[data-status="blue"] {
	background-color: #4082d3;
}

.item-tag[data-status="1"],
.item-tag[data-status="green"] {
	background-color: #4faa80;
}

.item-tag[data-status="2"],
.item-tag[data-status="red"] {
	background-color: #c55b5b;
}

.item-tag[data-status="3"],
.item-tag[data-status="yellow"] {
	background-color: #ffbe7a;
}

.item[data-theme="yellow"] .item-tag {
	color: #333;
}

.item-icon {
	font-size: 20px;
	margin-right: 10px;
	color: #4082d3;
}

.item.has-link .item-value {
	padding-right: 24px;
}

.item-link {
	margin-left: 10px;
	cursor: pointer;
	color: #4082d3;
	position: absolute;
    right: 0px;
}

.item-note {
	padding-left: 8px;
	color: #aaa;
}

.item-note:before {
	content: '/';
	padding-right: 5px;
}

</style>